module.exports = __webpack_public_path__ + "static/media/gem.6af4ffeb.svg";